module.exports = __webpack_public_path__ + "static/media/follower_token.28af293b.png";